function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD5CD",
  d: "M76.077 0L60 8.236 43.923 0l-9.805 15.171-18.041.906-.906 18.041L0 43.923 8.236 60 0 76.077l15.171 9.805.906 18.041 18.041.906L43.923 120 60 111.764 76.077 120l9.805-15.171 18.041-.906.905-18.041L120 76.077v-.001L111.764 60 120 43.924v-.001l-15.172-9.805-.905-18.041-18.041-.906z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAA9A",
  d: "M60 20.011l12.42-6.362 7.574 11.72 13.937.699.7 13.937 11.72 7.575L99.988 60l6.363 12.42-11.72 7.574-.7 13.937-13.937.7-7.574 11.72L60 99.988l-12.42 6.363-7.574-11.72-13.938-.7-.699-13.937-11.72-7.574L20.011 60l-6.362-12.42 11.72-7.575.699-13.937 13.938-.699 7.574-11.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002F34",
  d: "M71.2 42.4a8 8 0 100 16 8 8 0 000-16m0 5.6c1.323 0 2.4 1.077 2.4 2.4s-1.077 2.4-2.4 2.4-2.4-1.077-2.4-2.4 1.077-2.4 2.4-2.4m-24.8-5.6a8 8 0 100 16 8 8 0 000-16m0 5.6c1.323 0 2.4 1.077 2.4 2.4s-1.077 2.4-2.4 2.4-2.4-1.077-2.4-2.4 1.077-2.4 2.4-2.4M42.092 76.322l19.696 3.473.834-4.727-19.696-3.473z"
}));

const SvgErrorIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120
}, props), _ref);

export default SvgErrorIcon;